export enum ImageSourceKinds {
  None = 0,
  Format = 1,
  Cache = 2,
  Document = 3,
}
